import { Injectable } from '@angular/core';
import { createSelector, select, Store } from '@ngrx/store';
import { filter, map, Observable } from 'rxjs';

import { ProjectItemEntity } from '../components/project-list/project-item.entity';
import { ProjectListEntity } from '../components/project-list/project-list.entity';
import { featureSelector, ProjectRootState } from './feature.store';
import { ProjectSliceState, ProjectSliceKey } from './project.state';

const baseSelector = createSelector(
	featureSelector,
	(state) => state[ProjectSliceKey]
);

const projectsSelector = createSelector(
	baseSelector,
	(state) => state.projects
);

const loadingSelector = createSelector(baseSelector, (state) => state.loading);
const viewModeSelector = createSelector(
	baseSelector,
	(state) => state.projectsViewMode
);
const searchTermSelector = createSelector(
	baseSelector,
	(state) => state.searchTerm
);

const loadingMembersSelector = createSelector(
	baseSelector,
	(state) => state.isLoadingMembers
);

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const projectById = (id: number) =>
	createSelector(
		projectsSelector,
		(projects) => projects.elements.get(`${id}`) as ProjectItemEntity
	);

const isDeletingInProgressSelector = createSelector(
	baseSelector,
	(state) => state.isDeletingInProgress
);

const hasOrphanProjectsSelector = createSelector(
	baseSelector,
	(state) => state.hasOrphanProjects
);
@Injectable()
export class ProjectSelector {
	public constructor(private readonly store: Store<ProjectRootState>) {}

	private get state(): Observable<ProjectSliceState> {
		return this.store.pipe(select(baseSelector));
	}
	public getLoading$(): Observable<boolean> {
		return this.store.pipe(select(loadingSelector));
	}
	public getProjectList$(): Observable<ProjectListEntity> {
		return this.store.pipe(select(projectsSelector));
	}

	public getProjectsViewMode$(): Observable<string> {
		return this.store.pipe(select(viewModeSelector));
	}
	public getSearchTerm$(): Observable<string> {
		return this.store.pipe(select(searchTermSelector));
	}
	public getLoadingMembers$(): Observable<boolean> {
		return this.store.pipe(select(loadingMembersSelector));
	}

	public getProject$(id: number): Observable<ProjectItemEntity> {
		return this.store.pipe(select(projectById(id)));
	}

	public isDeletingInProgress$(): Observable<boolean> {
		return this.store.pipe(select(isDeletingInProgressSelector));
	}

	public hasOrphanProjects$(): Observable<boolean> {
		return this.store.pipe(select(hasOrphanProjectsSelector));
	}
}
